import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${props => props.theme.colors.success.surface};
  padding: ${props => props.theme.spacing.sp4};
  border-radius: ${props => props.theme.spacing.sp4};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  color: ${props => props.theme.colors.success.hover};
  max-height: ${props => (props.size === 'medium' ? 'none' : '1.5rem')};
`

export const WidgetLink = styled.a`
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
`
